import { User } from "../../model/User";

export interface ColumnAccess {
    hideLeadDate: boolean;
    hideDuration: boolean;
    hideType: boolean;
    hideLeadOutcome: boolean;
    hideNamePhone: boolean;
    hideApptDt: boolean;
    hideOptions: boolean;
    hideCustomColumn1: boolean;
    hideCustomColumn2: boolean;
    hideCustomColumn3: boolean;
    hideCustomColumn4: boolean;
}

//Function that returns a filled ColumnAccess object out of a User object
export function fillColumnAccess(user: User): ColumnAccess {
    return {
        hideLeadDate: user.HasForbiddenAccess("Can Read Lead Date"),
        hideDuration: user.HasForbiddenAccess("Can Read Duration"),
        hideType: user.HasForbiddenAccess("Can Read Type"),
        hideLeadOutcome: user.HasForbiddenAccess("Can Read Lead Outcome"),
        hideNamePhone: user.HasForbiddenAccess("Can Read Name Phone"),
        hideApptDt: user.HasForbiddenAccess("Can Read Appt Date"),
        hideOptions: user.HasForbiddenAccess("Can Read Options"),
        hideCustomColumn1: user.HasForbiddenAccess("Can Read Custom Column 1"),
        hideCustomColumn2: user.HasForbiddenAccess("Can Read Custom Column 2"),
        hideCustomColumn3: user.HasForbiddenAccess("Can Read Custom Column 3"),
        hideCustomColumn4: user.HasForbiddenAccess("Can Read Custom Column 4"),
    };
}